import React from 'react'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'

function index() {
  return (
    <div>
      <SubPageBreadCrumbs />
      Sales</div>
  )
}

export default index